goog.provide("shadow.js.shim.module$$mui$icons_material$Error$default");
shadow.js.shim.module$$mui$icons_material$Error$default = shadow.js.shim.module$$mui$icons_material$Error.default;
